(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
    console.log("C O U N T D O W N");
    const closingTimes = {
        0: "",      // Sunday
        1: "15:30", // Monday
        2: "15:30", // Tuesday
        3: "15:30", // Wednesday
        4: "15:30", // Thursday
        5: "15:00", // Friday
        6: ""       // Saturday
    };

    const danishTime = new Date().toLocaleString('da-DK', { timeZone: 'Europe/Copenhagen',year:"numeric", month: "2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit", second:"2-digit" }).replace(", ",".");
    const parts = danishTime.split(".");    
    const danishD = parts[2]+"-"+parts[1]+"-"+parts[0];
    const danishT = parts[3]+":"+parts[4]+":"+parts[5];
    const danishDT = danishD+"T"+danishT;
    const danishDay = new Date(danishDT).getDay();
    const closingTimeStr = danishD+"T"+closingTimes[danishDay];
    const closingTime = new Date(closingTimeStr);
    const closingTimeUTC = new Date(closingTime.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }));

    //console.log(danishDT); console.log(danishDay); console.log(closingTime.toString());

    function updateCountdown() {
      const now = new Date(); // Brugerens lokale tid
      const diff = closingTimeUTC - now;

      if (diff <= 0) {
        document.getElementById("countdown").textContent = "Countdown completed!";
        clearInterval(interval); // Stop intervallet
        return;
      }

      // Beregn dage, timer, minutter og sekunder
      //var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); hours = ("00" + hours).slice(-2);
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)); minutes = ("00" + minutes).slice(-2);
      var seconds = Math.floor((diff % (1000 * 60)) / 1000); seconds = ("00" + seconds).slice(-2);

      // Vis countdown-timeren
      //document.getElementById("countdown").textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      document.getElementById("countdown").textContent = `${hours}:${minutes}:${seconds}`;
    }

    // Start countdown-timeren
    const interval = setInterval(updateCountdown, 1000);
    updateCountdown(); // Opdater straks ved load

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
